<template>
  <div>home</div>
</template>
<script>

  export default {
    methods: {
      redirectIfUserExists() {
        if (this.$store.state.user && this.$store.state.user.role === 'ADMIN')
          this.$router.replace('/new-clients')
        else
          this.$router.replace('/declarations')
      }
    },
    watch: {
      '$store.state.user'() {
        this.redirectIfUserExists()
      }
    },
    created() {
      this.redirectIfUserExists()
    }
  }
</script>
